// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"vz_a bhh_b","TwoDimsListFeature__item":"vz_b bhh_wb","TwoDimsListFeature__item__text":"vz_c bhh_vr"};